import styles from './AgentCard.module.scss';
import { Typography, Dropdown, Button, Rate, Tag } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import editImg from '@/assets/images/common/edit.png';
import deleteImg from '@/assets/images/common/delete.png';
import React from "react";
import { useT } from '@/common/utils/translation';
import useIsMobile from "@/common/hooks/useIsMobile.js";
import CoverImage from "@/pages/components/CoverImage";

const { Paragraph, Text } = Typography;

function AgentCard({
  cardInfo = {},
  editAble,
  editDelete,
  className,
  onClick,
  onEdit,
  style,
  sortHandRender,
  detailButtonRef,
  detailActionLabel
}) {
  const [isMobile] = useIsMobile();
  let t = useT();

  // 获取工作流数据，智能体的信息主要来自其关联的工作流
  const workFlowData = cardInfo.workFlow || {};
  
  // 数据回退逻辑：优先使用workFlow数据，其次使用cardInfo直接字段
  const displayData = {
    titleCn: workFlowData.titleCn || cardInfo.name || cardInfo.titleCn,
    titleEn: workFlowData.titleEn || cardInfo.nameEn || cardInfo.titleEn,
    detailCn: workFlowData.detail || workFlowData.detailCn || cardInfo.description || cardInfo.detailCn || '暂无详情',
    detailEn: workFlowData.detailEn || cardInfo.descriptionEn || cardInfo.detailEn || 'No details available',
    coverImage: workFlowData.coverImage || cardInfo.coverImage,
    createBy: workFlowData.createBy || cardInfo.createBy,
    points: workFlowData.points || cardInfo.points
  };
  
  const items = [
    {
      label: <Text
        type="link"
        style={{display: 'flex', alignItems: 'center'}}
        onClick={(event) => {
          event.stopPropagation();
          onEdit?.('edit');
        }}
      >
        <img src={editImg} style={{height: '16px', width: '16px', marginRight: '8px'}}/>
        {t('createCenter_edit_application')}
      </Text>,
      key: '0',
    },
    {
      label: <Text
        type="danger"
        style={{display: 'flex', alignItems: 'center'}}
        onClick={(event) => {
          event.stopPropagation();
          onEdit?.('delete');
        }}
      >
        <img src={deleteImg} style={{height: '16px', width: '16px', marginRight: '8px'}}/>
        {t('createCenter_delete_delete')}
      </Text>,
      key: '1',
    },
  ];

  return (
    <div
      className={`${styles.container} ${className} ${onClick ? styles.hoverStyle : ''}`}
      style={{cursor: onClick ? 'pointer' : '', ...style}}
      onClick={() => {
        onClick?.();
      }}
    >
      <div className={styles.dragHand}>
        {sortHandRender}
      </div>
      
      {/* 大封面图 */}
      <div className={styles.coverContainer}>
        <CoverImage 
          coverImage={displayData.coverImage}
          width="100%"
          height="100%" // 改为100%，完全填充容器
          style={{ 
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            borderRadius: '8px 8px 0 0'
          }} // 确保封面完全显示
        />
        
        {/* 使用次数和评分都在封面右下角 */}
        <div className={styles.coverStats}>
          {/* 使用次数 */}
          {cardInfo.usage && (
            <div className={styles.usageDisplay}>
              <Text style={{ fontSize: '10px', color: 'white', fontWeight: 500 }}>
                {cardInfo.usage}次
              </Text>
            </div>
          )}
          
          {/* 评分 */}
          {displayData.points && (
            <div className={styles.coverRating}>
              <Rate disabled defaultValue={displayData.points} size="small" />
            </div>
          )}
        </div>
      </div>

      {/* 智能体标识标签 */}
      <div className={styles.agentBadge}>
        <Tag color="green" size="small">智能体</Tag>
      </div>

      {/* 标题和详情 */}
      <div className={styles.content}>
        <div className={styles.titleSection}>
          <Paragraph ellipsis={{rows: 1}} className={styles.cardTitle}>
            {detailButtonRef ? <button type="button" ref={detailButtonRef} className="maintenance-detail-trigger" data-detail-trigger={`application-agent:${cardInfo.id ?? cardInfo.appId}`}
              aria-label={`${detailActionLabel}: ${displayData.titleCn}`} onClick={event => { event.stopPropagation(); onClick?.(); }}>{displayData.titleCn}</button> : displayData.titleCn}
          </Paragraph>
        </div>

        <Paragraph ellipsis={{rows: 2}} className={styles.cardDescription}>
          {displayData.detailCn}
        </Paragraph>

        {/* 底部只保留创建者信息 */}
        <div className={styles.footer}>
          <div className={styles.meta}>
            <div className={styles.createBy}>
              {displayData.createBy}
            </div>
          </div>
        </div>
      </div>
      
      {/* 删除按钮在卡片右下角 */}
      {(editAble || editDelete) && (
        <div className={styles.cardEditButton} onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}>
          <Dropdown menu={{
            items: items.filter(item => {
              return editDelete ? item.key === '1' : true;
            })
          }}>
            <span className={styles.editButton}>
              <MoreOutlined style={{fontSize: '14px', transform: 'rotate(90deg)'}}/>
            </span>
          </Dropdown>
        </div>
      )}
    </div>
  );
}

export default AgentCard;
